class TokenService {
    
    getAccessToken() {
        const user = JSON.parse(localStorage.getItem("donor-x-lily"));
        return user?.token;
    }

    updateAccessToken(token) {
        let user = JSON.parse(localStorage.getItem("donor-x-lily"));
        user.token = token;
        localStorage.setItem("donor-x-lily", JSON.stringify(user));
    }

    getUser() {
        return JSON.parse(localStorage.getItem("donor-x-lily"));
    }

    setUser(data) {
        localStorage.setItem("donor-x-lily", JSON.stringify(data));
    }

    removeUser() {
        const userId = this.getUserId();
        localStorage.removeItem("donor-x-lily");
        localStorage.removeItem("administator-menus");
        localStorage.removeItem("isIdle");
        localStorage.removeItem("previous-url");
        localStorage.removeItem(`${userId}_isIdle`);
        localStorage.removeItem("donor-x-lily-permissions");
    }

    getUserId() {
        const userData = JSON.parse(localStorage.getItem("donor-x-lily"));
        return userData?.user?.id;
    }

    updatePrevLink(link) {
        localStorage.setItem("previous-url", link);
    }

    getPrevLink() {
        return localStorage.getItem("previous-url");
    }

    updateAdministratorMenu(menus) {
        localStorage.setItem("administator-menus", JSON.stringify(menus));
    }

    getAdministratorMenu(menus) {
        return JSON.parse(localStorage.getItem("administator-menus"));
    }

    setUserIdle(status) {
        const userId = this.getUserId();
        localStorage.setItem(`${userId}_isIdle`, status);
    }

    getUserIdle() {
        const userId = this.getUserId();
        return localStorage.getItem(`${userId}_isIdle`);
    }

    getUserData() {
        const userData = JSON.parse(localStorage.getItem("donor-x-lily"));
        return typeof userData !== 'undefined' ? userData?.user : {};
    }

    getUserRoles() {
        const userData = JSON.parse(localStorage.getItem("donor-x-lily"));
        return userData?.roles;
    }

    updateUserRoles(roles) {
        let user = JSON.parse(localStorage.getItem("donor-x-lily"));
        user.roles = roles;
        localStorage.setItem("donor-x-lily", JSON.stringify(user));
    }

    updateUserMenu(menus) {
        let user = JSON.parse(localStorage.getItem("donor-x-lily"));
        user.menus = menus;
        localStorage.setItem("donor-x-lily", JSON.stringify(user));
    }

    updateUser(userInput) {
        let userData = JSON.parse(localStorage.getItem("donor-x-lily"));
        userData.user = userInput;
        localStorage.setItem("donor-x-lily", JSON.stringify(userData));
    }

    setUserRestrictions(permissions) {
        localStorage.setItem("donor-x-lily-permissions", JSON.stringify(permissions));
    }

    getUserRestrictions() {
        return localStorage.getItem("donor-x-lily-permissions");
    }
}

export default new TokenService();